import React from "react";
import {Control} from "react-hook-form/dist/types";
import {AziendaRecord} from "@commons/mapping/AziendaRecord";
import {Controller, FieldPath} from "react-hook-form";
import ComboBox from "./ComboBox";
import {CCNLRecord, SettoreContrattiRecord} from "@commons/mapping/SettoriCCNL";
import {FornitoreRecord} from "@commons/mapping/FornitoreRecord";
import {VoceTicket} from "@commons/mapping/PVABase";
import {FieldValues} from "react-hook-form/dist/types/fields";
import {EntePrevidenzialeRecord} from "@commons/mapping/EntePrevidenzialeRecord";


export function ComboBoxSettoreCCNL<T extends FieldValues>(props: {
                                                               control: Control<T>,
                                                               name: FieldPath<T>,
                                                               defaultValue: any,
                                                               label: string,
                                                               data: SettoreContrattiRecord[] | undefined,
                                                               isLoading?: boolean,
                                                               onChange?: (v: SettoreContrattiRecord | null) => void
                                                           }
) {
    const onChangeSettore = props.onChange ? props.onChange : (v: SettoreContrattiRecord | null) => {
    };
    return <Controller name={props.name}
                       control={props.control}
                       defaultValue={props.defaultValue}
                       rules={{required: true}}
                       render={({field: {value, onChange}, fieldState}) => {
                           return (
                               <ComboBox<SettoreContrattiRecord> label={props.label} value={{settore: value}} onChange={(value) => {
                                   onChange(value?.settore);
                                   onChangeSettore(value)
                               }}
                                                                 data={props.data} isLoading={props.isLoading}
                                                                 searchablePropsName={["settore"]}
                                                                 fieldState={fieldState}
                                                                 isSameFn={(a, z) => (a && z) ? a.settore === z.settore : false}
                                                                 keyValueFn={(v) => v.settore!}
                                                                 displayValueFn={(v) => props.data && v ? v.settore! : ''}
                               />
                           )
                       }}
    />
}

export const ComboBoxCCNL: React.FC<{
    control: Control<AziendaRecord>,
    name: FieldPath<AziendaRecord>,
    defaultValue: string | null,
    label: string,
    data: CCNLRecord[] | undefined,
    isLoading?: boolean,
    valueSelected: any,
}> = ({control, name, defaultValue, label, data, isLoading, valueSelected,}) => {
    return <Controller name={name}
                       control={control}
                       defaultValue={defaultValue}
                       rules={{required: true}}
                       render={({field: {value, onChange}, fieldState}) => {
                           return (
                               <ComboBox<CCNLRecord> label={label} value={valueSelected} onChange={onChange} fieldState={fieldState}
                                                     data={data}
                                                     isLoading={isLoading}
                                                     searchablePropsName={["descrizione", "codContratto", "codContrattoUNILAV"]}
                                                     isSameFn={(a, z) => (a && z) ? (a.codContratto === z.codContratto && a.codContrattoUNILAV === z.codContrattoUNILAV) : false}
                                                     keyValueFn={(v) => v.codContratto + '-' + v.codContrattoUNILAV}
                                                     displayValueFn={(v) => data && v ? (v.descrizione + ` [#${v.codContrattoUNILAV}/${v.codContratto}]`) : ''}
                               />
                           )
                       }}
    />
};


export function ComboBoxEntePrev<T extends FieldValues>(props: {
                                                            control: Control<T>, name: FieldPath<T>, defaultValue: any, label?: string,
                                                            data: EntePrevidenzialeRecord[] | undefined, isLoading?: boolean, onChange?: (v: EntePrevidenzialeRecord | null) => void
                                                        }
) {
    return <Controller name={props.name}
                       control={props.control}
                       defaultValue={props.defaultValue}
                       rules={{required: true}}
                       render={({field: {value, onChange}, fieldState}) => {
                           return (
                               <ComboBox<EntePrevidenzialeRecord> label={props.label} value={{codEnte: value}} onChange={(value) => {
                                   onChange(value?.codEnte);
                               }}
                                                                  data={props.data} isLoading={props.isLoading}
                                                                  searchablePropsName={["codEnte", "descrizione"]}
                                                                  fieldState={fieldState}
                                                                  isSameFn={(a, z) => (a && z) ? a.codEnte === z.codEnte : false}
                                                                  keyValueFn={(v) => v.codEnte!}
                                                                  displayValueFn={(v) => props.data && v ? `${v.descrizione} [#${v.codEnte}]` : ''}
                               />
                           )
                       }}
    />
}

export function ComboBoxEnteAss<T extends FieldValues>(props: {
                                                           control: Control<T>, name: FieldPath<T>, defaultValue: any, label: string,
                                                           data: { descrizione: string, idGestione: number }[] | undefined, isLoading?: boolean, onChange?: (v: { descrizione: string, idGestione: number } | null) => void
                                                       }
) {
    return <Controller name={props.name}
                       control={props.control}
                       defaultValue={props.defaultValue}
                       rules={{required: true}}
                       render={({field: {value, onChange}, fieldState}) => {
                           return (
                               <ComboBox<{ descrizione: string, idGestione: number }> label={props.label} value={{idGestione: value}} onChange={(value) => {
                                   onChange(value?.idGestione);
                               }}
                                                                                      data={props.data} isLoading={props.isLoading}
                                                                                      searchablePropsName={["idGestione", "descrizione"]}
                                                                                      fieldState={fieldState}
                                                                                      isSameFn={(a, z) => (a && z) ? a.idGestione === z.idGestione : false}
                                                                                      keyValueFn={(v) => v.idGestione!}
                                                                                      displayValueFn={(v) => props.data && v ? `${v.descrizione} [#${v.idGestione}]` : ''}
                               />
                           )
                       }}
    />
}

export function ComboBoxInail<T extends FieldValues>(props: {
                                                         control: Control<T>, name: FieldPath<T>, defaultValue: any, label: string,
                                                         data: { descrizione: string, idSede: number }[] | undefined, isLoading?: boolean, onChange?: (v: { descrizione: string, idSede: number } | null) => void
                                                     }
) {
    return <Controller name={props.name}
                       control={props.control}
                       defaultValue={props.defaultValue}
                       rules={{required: true}}
                       render={({field: {value, onChange}, fieldState}) => {
                           return (
                               <ComboBox<{ descrizione: string, idSede: number }> label={props.label} value={{idSede: value}} onChange={(value) => {
                                   onChange(value?.idSede);
                               }}
                                                                                  data={props.data} isLoading={props.isLoading}
                                                                                  searchablePropsName={["idSede", "descrizione"]}
                                                                                  fieldState={fieldState}
                                                                                  isSameFn={(a, z) => (a && z) ? a.idSede === z.idSede : false}
                                                                                  keyValueFn={(v) => v.idSede!}
                                                                                  displayValueFn={(v) => props.data && v ? `${v.descrizione} [#${v.idSede}]` : ''}
                               />
                           )
                       }}
    />
}

export function ComboBoxFornitore<T extends FieldValues>(props: {
                                                             control: Control<T>, name: FieldPath<T>, defaultValue: any, label: string,
                                                             data: any, isLoading?: boolean, onChange?: (v: FornitoreRecord | null) => void,
                                                             disabled: boolean,
                                                         }
) {
    return <Controller name={props.name}
                       control={props.control}
                       defaultValue={props.defaultValue}
                       rules={{required: true}}
                       render={({field: {value, onChange}, fieldState}) => {
                           return (
                               <ComboBox<FornitoreRecord> label={props.label} value={{idFornitore: value}} onChange={(value) => {
                                   onChange(value?.idFornitore);
                               }}
                                                          data={props.data} isLoading={props.isLoading}
                                                          disabled={props.disabled}
                                                          searchablePropsName={["nominativo"]}
                                                          fieldState={fieldState}
                                                          isSameFn={(a, z) => (a && z) ? a.idFornitore === z.idFornitore : false}
                                                          keyValueFn={(v) => v.idFornitore!}
                                                          displayValueFn={(v) => props.data && v ? `${v.nominativo} [#${v.idFornitore}]` : ''}
                               />
                           )
                       }}
    />
}

export const ComboBoxVoceTk: React.FC<{
    control: Control<AziendaRecord>,
    name: FieldPath<AziendaRecord>,
    defaultValue: number,
    label?: string,
    data?: VoceTicket[],
    onChange?: (v: FornitoreRecord | null) => void,
    isLoading?: boolean
    disabled?: boolean
}> = ({control, name, defaultValue, label, data, onChange, isLoading, disabled}) => {

    return <Controller name={name}
                       control={control}
                       defaultValue={defaultValue}
                       rules={{required: true}}
                       render={({field: {value, onChange}, fieldState}) => {
                           return (
                               <ComboBox<VoceTicket> label={label} value={{codVoce: value}}
                                                     onChange={(v) => {
                                                         onChange(v)
                                                     }}
                                                     fieldState={fieldState}
                                                     data={data}
                                                     isLoading={isLoading}
                                                     searchablePropsName={['descrizioneVoce']}
                                                     disabled={disabled}
                                                     isSameFn={(a, z) => (a && z) ? a.codVoce === z.codVoce : false}
                                                     keyValueFn={(v) => v.codVoce!}
                                                     displayValueFn={(v) => data && v ? v.descrizioneVoce! + ' [#' + v.codVoce + ']' : ''}
                               />
                           )
                       }}
    />
}